"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockedSource = void 0;

var quick_lru_1 = __importDefault(require("quick-lru"));

var basesource_js_1 = require("./basesource.js");

var utils_js_1 = require("../utils.js");

var Block = /*#__PURE__*/function () {
  /**
   *
   * @param {number} offset
   * @param {number} length
   * @param {ArrayBuffer} [data]
   */
  function Block(offset, length) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    (0, _classCallCheck2.default)(this, Block);
    this.offset = offset;
    this.length = length;
    this.data = data;
  }
  /**
   * @returns {number} the top byte border
   */


  (0, _createClass2.default)(Block, [{
    key: "top",
    get: function get() {
      return this.offset + this.length;
    }
  }]);
  return Block;
}();

var BlockGroup = /*#__PURE__*/(0, _createClass2.default)(
/**
 *
 * @param {number} offset
 * @param {number} length
 * @param {number[]} blockIds
 */
function BlockGroup(offset, length, blockIds) {
  (0, _classCallCheck2.default)(this, BlockGroup);
  this.offset = offset;
  this.length = length;
  this.blockIds = blockIds;
});

var BlockedSource = /*#__PURE__*/function (_basesource_js_1$Base) {
  (0, _inherits2.default)(BlockedSource, _basesource_js_1$Base);

  var _super = _createSuper(BlockedSource);

  /**
   *
   * @param {BaseSource} source The underlying source that shall be blocked and cached
   * @param {object} options
   * @param {number} [options.blockSize]
   * @param {number} [options.cacheSize]
   */
  function BlockedSource(source) {
    var _this;

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$blockSize = _ref.blockSize,
        blockSize = _ref$blockSize === void 0 ? 65536 : _ref$blockSize,
        _ref$cacheSize = _ref.cacheSize,
        cacheSize = _ref$cacheSize === void 0 ? 100 : _ref$cacheSize;

    (0, _classCallCheck2.default)(this, BlockedSource);
    _this = _super.call(this);
    _this.source = source;
    _this.blockSize = blockSize;
    _this.blockCache = new quick_lru_1.default({
      maxSize: cacheSize,
      onEviction: function onEviction(blockId, block) {
        _this.evictedBlocks.set(blockId, block);
      }
    });
    /** @type {Map<number, Block>} */

    _this.evictedBlocks = new Map(); // mapping blockId -> Block instance

    _this.blockRequests = new Map(); // set of blockIds missing for the current requests

    _this.blockIdsToFetch = new Set();
    _this.abortedBlockIds = new Set();
    return _this;
  }

  (0, _createClass2.default)(BlockedSource, [{
    key: "fileSize",
    get: function get() {
      return this.source.fileSize;
    }
    /**
     *
     * @param {import("./basesource").Slice[]} slices
     */

  }, {
    key: "fetch",
    value: function () {
      var _fetch = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(slices, signal) {
        var _this2 = this;

        var blockRequests, missingBlockIds, allBlockIds, _iterator, _step, _step$value, offset, length, top, fileSize, firstBlockOffset, current, _blockId2, missingRequests, _i, _missingBlockIds, blockId, abortedBlockRequests, abortedBlockIds, _iterator2, _step2, _blockId, block, blocks, failedBlocks, requiredBlocks;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                blockRequests = [];
                missingBlockIds = [];
                allBlockIds = [];
                this.evictedBlocks.clear();
                _iterator = _createForOfIteratorHelper(slices);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _step$value = _step.value, offset = _step$value.offset, length = _step$value.length;
                    top = offset + length;
                    fileSize = this.fileSize;

                    if (fileSize !== null) {
                      top = Math.min(top, fileSize);
                    }

                    firstBlockOffset = Math.floor(offset / this.blockSize) * this.blockSize;

                    for (current = firstBlockOffset; current < top; current += this.blockSize) {
                      _blockId2 = Math.floor(current / this.blockSize);

                      if (!this.blockCache.has(_blockId2) && !this.blockRequests.has(_blockId2)) {
                        this.blockIdsToFetch.add(_blockId2);
                        missingBlockIds.push(_blockId2);
                      }

                      if (this.blockRequests.has(_blockId2)) {
                        blockRequests.push(this.blockRequests.get(_blockId2));
                      }

                      allBlockIds.push(_blockId2);
                    }
                  } // allow additional block requests to accumulate

                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                _context.next = 8;
                return (0, utils_js_1.wait)();

              case 8:
                this.fetchBlocks(signal); // Gather all of the new requests that this fetch call is contributing to `fetch`.

                missingRequests = [];

                for (_i = 0, _missingBlockIds = missingBlockIds; _i < _missingBlockIds.length; _i++) {
                  blockId = _missingBlockIds[_i];

                  // The requested missing block could already be in the cache
                  // instead of having its request still be outstanding.
                  if (this.blockRequests.has(blockId)) {
                    missingRequests.push(this.blockRequests.get(blockId));
                  }
                } // Actually await all pending requests that are needed for this `fetch`.


                _context.next = 13;
                return Promise.allSettled(blockRequests);

              case 13:
                _context.next = 15;
                return Promise.allSettled(missingRequests);

              case 15:
                // Perform retries if a block was interrupted by a previous signal
                abortedBlockRequests = [];
                abortedBlockIds = allBlockIds.filter(function (id) {
                  return _this2.abortedBlockIds.has(id) || !_this2.blockCache.has(id);
                });
                abortedBlockIds.forEach(function (id) {
                  return _this2.blockIdsToFetch.add(id);
                }); // start the retry of some blocks if required

                if (!(abortedBlockIds.length > 0 && signal && !signal.aborted)) {
                  _context.next = 41;
                  break;
                }

                this.fetchBlocks(null);
                _iterator2 = _createForOfIteratorHelper(abortedBlockIds);
                _context.prev = 21;

                _iterator2.s();

              case 23:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 31;
                  break;
                }

                _blockId = _step2.value;
                block = this.blockRequests.get(_blockId);

                if (block) {
                  _context.next = 28;
                  break;
                }

                throw new Error("Block ".concat(_blockId, " is not in the block requests"));

              case 28:
                abortedBlockRequests.push(block);

              case 29:
                _context.next = 23;
                break;

              case 31:
                _context.next = 36;
                break;

              case 33:
                _context.prev = 33;
                _context.t0 = _context["catch"](21);

                _iterator2.e(_context.t0);

              case 36:
                _context.prev = 36;

                _iterator2.f();

                return _context.finish(36);

              case 39:
                _context.next = 41;
                return Promise.allSettled(abortedBlockRequests);

              case 41:
                if (!(signal && signal.aborted)) {
                  _context.next = 43;
                  break;
                }

                throw new utils_js_1.AbortError('Request was aborted');

              case 43:
                blocks = allBlockIds.map(function (id) {
                  return _this2.blockCache.get(id) || _this2.evictedBlocks.get(id);
                });
                failedBlocks = blocks.filter(function (i) {
                  return !i;
                });

                if (!failedBlocks.length) {
                  _context.next = 47;
                  break;
                }

                throw new utils_js_1.AggregateError(failedBlocks, 'Request failed');

              case 47:
                // create a final Map, with all required blocks for this request to satisfy
                requiredBlocks = new Map((0, utils_js_1.zip)(allBlockIds, blocks)); // TODO: satisfy each slice

                return _context.abrupt("return", this.readSliceData(slices, requiredBlocks));

              case 49:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[21, 33, 36, 39]]);
      }));

      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
    /**
     *
     * @param {AbortSignal} signal
     */

  }, {
    key: "fetchBlocks",
    value: function fetchBlocks(signal) {
      var _this3 = this;

      // check if we still need to
      if (this.blockIdsToFetch.size > 0) {
        (function () {
          var groups = _this3.groupBlocks(_this3.blockIdsToFetch); // start requesting slices of data


          var groupRequests = _this3.source.fetch(groups, signal);

          var _loop = function _loop(groupIndex) {
            var group = groups[groupIndex];

            var _iterator3 = _createForOfIteratorHelper(group.blockIds),
                _step3;

            try {
              var _loop2 = function _loop2() {
                var blockId = _step3.value;

                // make an async IIFE for each block
                _this3.blockRequests.set(blockId, (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
                  var response, blockOffset, o, t, data, block;
                  return _regenerator.default.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.prev = 0;
                          _context2.next = 3;
                          return groupRequests;

                        case 3:
                          _context2.t0 = groupIndex;
                          response = _context2.sent[_context2.t0];
                          blockOffset = blockId * _this3.blockSize;
                          o = blockOffset - response.offset;
                          t = Math.min(o + _this3.blockSize, response.data.byteLength);
                          data = response.data.slice(o, t);
                          block = new Block(blockOffset, data.byteLength, data, blockId);

                          _this3.blockCache.set(blockId, block);

                          _this3.abortedBlockIds.delete(blockId);

                          _context2.next = 23;
                          break;

                        case 14:
                          _context2.prev = 14;
                          _context2.t1 = _context2["catch"](0);

                          if (!(_context2.t1.name === 'AbortError')) {
                            _context2.next = 22;
                            break;
                          }

                          // store the signal here, we need it to determine later if an
                          // error was caused by this signal
                          _context2.t1.signal = signal;

                          _this3.blockCache.delete(blockId);

                          _this3.abortedBlockIds.add(blockId);

                          _context2.next = 23;
                          break;

                        case 22:
                          throw _context2.t1;

                        case 23:
                          _context2.prev = 23;

                          _this3.blockRequests.delete(blockId);

                          return _context2.finish(23);

                        case 26:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[0, 14, 23, 26]]);
                }))());
              };

              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                _loop2();
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          };

          for (var groupIndex = 0; groupIndex < groups.length; ++groupIndex) {
            _loop(groupIndex);
          }

          _this3.blockIdsToFetch.clear();
        })();
      }
    }
    /**
     *
     * @param {Set} blockIds
     * @returns {BlockGroup[]}
     */

  }, {
    key: "groupBlocks",
    value: function groupBlocks(blockIds) {
      var sortedBlockIds = Array.from(blockIds).sort(function (a, b) {
        return a - b;
      });

      if (sortedBlockIds.length === 0) {
        return [];
      }

      var current = [];
      var lastBlockId = null;
      var groups = [];

      var _iterator4 = _createForOfIteratorHelper(sortedBlockIds),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var blockId = _step4.value;

          if (lastBlockId === null || lastBlockId + 1 === blockId) {
            current.push(blockId);
            lastBlockId = blockId;
          } else {
            groups.push(new BlockGroup(current[0] * this.blockSize, current.length * this.blockSize, current));
            current = [blockId];
            lastBlockId = blockId;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      groups.push(new BlockGroup(current[0] * this.blockSize, current.length * this.blockSize, current));
      return groups;
    }
    /**
     *
     * @param {import("./basesource").Slice[]} slices
     * @param {Map} blocks
     */

  }, {
    key: "readSliceData",
    value: function readSliceData(slices, blocks) {
      var _this4 = this;

      return slices.map(function (slice) {
        var top = slice.offset + slice.length;

        if (_this4.fileSize !== null) {
          top = Math.min(_this4.fileSize, top);
        }

        var blockIdLow = Math.floor(slice.offset / _this4.blockSize);
        var blockIdHigh = Math.floor(top / _this4.blockSize);
        var sliceData = new ArrayBuffer(slice.length);
        var sliceView = new Uint8Array(sliceData);

        for (var blockId = blockIdLow; blockId <= blockIdHigh; ++blockId) {
          var block = blocks.get(blockId);
          var delta = block.offset - slice.offset;
          var topDelta = block.top - top;
          var blockInnerOffset = 0;
          var rangeInnerOffset = 0;
          var usedBlockLength = void 0;

          if (delta < 0) {
            blockInnerOffset = -delta;
          } else if (delta > 0) {
            rangeInnerOffset = delta;
          }

          if (topDelta < 0) {
            usedBlockLength = block.length - blockInnerOffset;
          } else {
            usedBlockLength = top - block.offset - blockInnerOffset;
          }

          var blockView = new Uint8Array(block.data, blockInnerOffset, usedBlockLength);
          sliceView.set(blockView, rangeInnerOffset);
        }

        return sliceData;
      });
    }
  }]);
  return BlockedSource;
}(basesource_js_1.BaseSource);

exports.BlockedSource = BlockedSource;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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